import GetUserToken from "../utils/GetUserToken";
import { parseJSON } from "../utils/parseJSON";

const urlBase = `${process.env.REACT_APP_API_URL_V2}/herbs`;
const readUrl = (url = "") => `${urlBase}/${url}`;

class Herb {
  async getOne({ id }) {
    console.log("getOne - herbs - service", id);
    const auth = `Bearer ${GetUserToken()}`;

    let res = await fetch(readUrl(id), {
      method: "GET",
      headers: {
        Authorization: auth,
        "Content-Type": "application/json",
        "api-key": process.env.REACT_APP_API_KEY,
      },
    });

    res = await parseJSON(res);
    return res;
  }

  async getAll(payload) {
    console.log("getAll - herbs - service", payload);
    const auth = `Bearer ${GetUserToken()}`;

    let res = await fetch(readUrl(), {
      method: "GET",
      headers: {
        Authorization: auth,
        "Content-Type": "application/json",
        "api-key": process.env.REACT_APP_API_KEY,
      },
    });

    res = await parseJSON(res);
    res.response = res.response.filter((herb) => !herb.owner_id);
    return res;
  }
}

const herb = new Herb();
export default herb;
